import React from "react";
import { path } from "ramda";
import { Cell, Header } from "./commonElements";
import i18n from "../../../../i18n.js";

const handleCellConstruct = row => {
    const sys = path(["original", "sys"], row);
    const dia = path(["original", "dia"], row);
    const value = sys && dia ? `${sys}/${dia}` : null;

    return <Cell row={row} value={value} unit="mmHg" />;
};

export const bloodPressureDef = iconTypes => ({
    minWidth: 92,
    accessor: d => d,
    id: "bloodPressure",
    Cell: handleCellConstruct,
    Header: () => <Header label={i18n.t("words.blood_pressure")} iconType={iconTypes.bloodPressure} />
});
